<template>
	<div style="margin-top: -1rem;">
		<div class="actDiv">
			<label style="margin-left:0.625rem ;">小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  @change="neighborChangeHandler">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<a-button size="small"   icon="cloud-download"  @click="download" style="margin-left: 0.5rem;">手持导出</a-button>
			<a-button size="small"   icon="cloud-upload"  @click="uploadFlag = true" style="margin-left: 0.5rem;">上传数据</a-button>
			<a-button size="small"   icon="export"  @click="download" style="margin-left: 0.5rem;">导出当前小区</a-button>
			<label style="margin-left:1.5rem ;">抄表批次</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theTimes">
				<a-select-option v-for="(item,index) in logList" :key="item.id" :value="item.id">{{getTheTime(item.create_time)}}</a-select-option>
			</a-select>
			<a-button  size="small"  @click="addReadMeterLog" style="margin-left: 0.5rem;" 
						:disabled="this.theNeighbor == undefined" :loading="addLoading">添加批次</a-button>
			<label style="margin-left:0.625rem ;color:red">添加批次仅用于没有远传表的小区使用</label>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="600"  ref="mTable" show-overflow="title" size="mini" :cell-style="cellClassName"
						  resizable highlight-hover-row :loading="loading"   row-id="pid"  :edit-config="{trigger: 'click', mode: 'cell'}">
						  <vxe-table-column type="seq" width="50"></vxe-table-column>
						  <vxe-table-column title="用户号" field="customerNum" width="85"></vxe-table-column>
						  <vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
						  <vxe-table-column title="扣费读数" field="deread" ></vxe-table-column>
						  <vxe-table-column title="表读数" field="readdata"  ></vxe-table-column>
						  <vxe-table-column title="抄表时间" field="readtime"  :formatter="getTimeFormatter"></vxe-table-column>
						  <vxe-table-column title="表读数" field="newReadData" :edit-render="{name: 'input',events: {keyup: enterEvent}}"></vxe-table-column>
						  <vxe-table-column title="用量"  width="60">
								<template #default="{ row }">
									<span :style="useCountStyle(row)">
										{{getUseCount(row)}}
									</span>
								</template>
						  </vxe-table-column>
						<vxe-table-column title="余额" field="CustomerBalance"></vxe-table-column>
						<vxe-table-column title="预付费">
								<template #default="{ row }">
									<span>
										{{getPrePaySign(row)}}
									</span>
								</template>
						</vxe-table-column>
						<vxe-table-column title="集中器" field="GPRSAddr"></vxe-table-column>
						<vxe-table-column title="采集器地址" field="CollectorAddr"></vxe-table-column>
						<vxe-table-column title="表地址" field="MeterAddr"></vxe-table-column>
						<vxe-table-column title="表状态" field="MeterState" :formatter="getMeterState"></vxe-table-column>
						<vxe-table-column title="操作" field="pid">
							<template #default="{ row }">
								<a-button size="small"  type="link" @click="addReadMeter(row)" >录入</a-button>
							</template>
						</vxe-table-column>
		</vxe-table>
		<a-modal v-model="uploadFlag" title="上传文件" @ok="submitUpload">
			<a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :disabled="uploading"
							accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
				<a-button type = "default" icon = "upload">选择文件 </a-button>
			</a-upload>
		</a-modal>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				list:[],
				logList:[],
				fileList:[],
				loading:false,
				addLoading:false,
				neighborList:[],
				theNeighbor:undefined,
				theTimes:null,
				uploadFlag:false,
				uploading: false,
			}
		},
		methods:{
			addTheMeterLog:function(theId,theData){
				let url = this.Api.getLastUrl(this.Api.NON_REMOTE_READ_DATA_ADD_URL);
				let param = {taskId:this.theTimes,newReadData:theData,type:this.getType(),meterId:theId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			enterEvent ({ $panel, column }, event) {
				if (event.keyCode == 13) {
					let newReadData = column.model.value;
					let index = this.$refs.mTable.getActiveRecord().rowIndex;
					let theId = this.list[index].pid;
					if(this.theTimes == null){
						this.$message.error('请选择抄表批次');
					}else if(newReadData==undefined||newReadData.length==0){
					}else{
						this.$refs.mTable.setActiveRow(this.list[index+1]);
						this.addTheMeterLog(theId,newReadData);
						this.reloadTheTable(newReadData,this.list[index]);
					}
				}
			},
			useCountStyle:function(row){
				let style= null;
				if((row.readdata+row.changend-row.deread)>=50){
					style = {
						backgroundColor:'#ffee00',
						color:'red',
					}
				}else if((row.readdata+row.changend-row.deread)<0){
					style = {
						fontWeight:'bold',
						color:'red',
					}
				}
				return style;
			},
			cellClassName({ row, rowIndex, column }){
				if(column.property == 'customerBalance'){
					if(row.customerBalance<=0){
						 return {
							 backgroundColor: '#ffee00',
							 color: '#ff0000'
						 }
					}
				}else{
					return {
						color:'#000',
					}
				}	
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			beforeUpload:function(file){
				let flag  = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				if(flag){
					this.fileList = [];
					this.fileList = [...this.fileList, file];
				}else{
					this.$message.error('只能上传Excel文件');
				}
				return false;
			},
			handleRemove:function(file){
				const index = this.fileList.indexOf(file);
				const newFileList = this.fileList.slice();
				newFileList.splice(index, 1);
				this.fileList = newFileList;
			},
			submitUpload:function(){
				if(this.theTimes == null){
					this.$message.error('请选择抄表批次');
				}else{
					this.uploading = true;
					const formData = new FormData();
					formData.append('file', this.fileList[0]);
					formData.append("taskId",this.theTimes);
					formData.append("type",this.getType());
					let url = this.Api.getLastUrl(this.Api.NON_REMOTE_READ_DATA_UPLOAD_URL);
					this.Api.fetchPostWithFiles(url,formData).then((data)=>{
						this.uploading = false;
						this.uploadFlag = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success(msg);
							this.queryListData();
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.uploadFlag = false;
						this.uploading = false;
						console.log(error);
					})
				}
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			neighborChangeHandler:function(){
				this.queryListData();
				this.theTimes = null;
			},
			download:function(){
				let url = this.Api.getLastUrl(this.Api.NON_REMOTE_EXPORT_URL);
				let param = {neighborId:this.theNeighbor.key,neighborName:this.theNeighbor.label};
				this.Api.fetchPostFile(url,param).then((res)=>{
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					var myDate = new Date();
					var date = myDate.getFullYear()+"-"+myDate.getMonth()+1+"-"+myDate.getDate();
					let fileName =date+this.theNeighbor.label+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					console.log(error);
				});
			},
			upload:function(){
				
			},
			getTheTime:function(theTime){
				if(theTime == null){
					return "";
				}else{
					let date = new Date(theTime);
					return this.Config.formatDate(date);
				}
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getMeterState:function(theV,){
				return this.Config.getValueByNameFromList(theV,this.Config.getMeterStateList());
			},
			queryListData:function(){
				if(this.theNeighbor == undefined || this.theNeighbor == null){
					return ;
				}
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_NON_REMOTE_METER_LIST_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
						this.queryReadMeterLogs();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			reloadTheTable:function(readData,theItem){
				theItem.readdata = readData;
				theItem.readtime = this.Config.formatDate(new Date());
				theItem.MeterState = 5;
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			addReadMeterLog:function(){
				this.addLoading = true;
				let url = this.Api.getLastUrl(this.Api.NON_REMOTE_READ_LOG_ADD_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.addLoading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('批次添加成功');
						this.queryReadMeterLogs();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.addLoading = false;
					console.log(error);
				});
			},
			queryReadMeterLogs:function(){
				let url = this.Api.getLastUrl(this.Api.NON_REMOTE_READ_LOG_LIST_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.logList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			addReadMeter:function(record){
				if(record.newReadData == undefined){
					this.$refs.mTable.setActiveRow(record);
				}else{
					if(this.theTimes == null){
						this.$message.error('请选择抄表批次');
					}else{
						let index = this.$refs.mTable.getRowIndex(record);
						this.$refs.mTable.setActiveRow(this.list[index+1]);
						this.addTheMeterLog(record.pid,record.newReadData);
						this.reloadTheTable(record.newReadData,this.list[index]);
					}
				}
			},
			getType:function(){
					let type = null;
					for(var i = 0;i<this.logList.length;i++){
						let item = this.logList[i];
						if(item.id == this.theTimes){
							type = item.type;
							break;
						}
					}
					return type;
			},
			getUseCount:function(item){
				if(item.changend>0){
					return item.readdata+item.changend-item.deread;
				}else{
					return item.readdata-item.deread;
				}
			},
			getPrePaySign:function(item){
				return item.prePaySign ==1 ?'预':'后';
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
		},
		created() {
			this.queryNeighbors();
		}
	}
</script>

<style>
</style>
